import PublicNav from '../Shared/PublicNav.js'
import PublicFooter from '../Shared/PublicFooter.js'

const PriceList=()=>
{
  
    return(
        <>
          <header id="header" class="">
  <div class="container d-flex align-items-center header-center justify-content-between"> <a href="index.html" class="logo"> <img src="../img/avt.png" alt="" class="img-fluid"/> </a>
    <div class="navbar navbar-expand-lg">
      <ul class="navbar-nav avt-top-menu">
      <li class="nav-item"> <a  aria-current="page" href="index.html">Home</a> </li>        
      <li class="nav-item"> <a href="#" class="active" >Pricing</a> </li>      
        <li class="nav-item"> <a href="#">Feature</a> </li>
        <li class="nav-item"> <a href="#">Contact</a> </li>
      </ul>
    </div>
   
  </div>
</header>
        <section class="pricing topsection">
  <div class="container"> 
  <div class="row"><div class="col-lg-5">
  <h3>Find the Perfect Fit : Vehicle Tracking Device Prices</h3>
    <p>Avaal Express is a comprehensive trucking management software solution incorporating dispatching, fleet management, driver management, safety and compliance, and accounting from a single easy-to-use platform.</p>
    </div></div>
  </div>
</section>
<section class="bg-light">
  <div class="container">
    <div class="row align-items-center">
      
      <div class="col-md-4 offset-md-4 text-center">
        <h3>Transparent Pricing</h3>
        <h5>A leading Vehicle Tracking Service Provider</h5>
        <p>AVAAL vehicle tracking (AVT) system provides a wide range
            GPS solutions for your commercial trucks with advanced montoring.</p>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container">
  <div class="row align-items-center">      
      <div class="col-md-6"> <img src="../img/gps.jpg" style={{"width":"350px"}} /> </div>
      <div class="col-md-6">
        <h4>AVT GPS Device</h4>
        <p> There are dedicated GPS tracking devices available in the market that you can attach to vehicles, or containers you want to track. These devices usually come with their own software or apps that allow you to monitor their location in real-time. AVT provide the latest technology devices to save on data, battery consumption and provides precise tracking.</p>        
        <h5>Plan</h5>
        <ul class="btn-list d-flex">
<li class="active">1 Year Plan</li>
<li>2 Year Plan</li>
<li>5 Year Plan</li>

        </ul>
        <p>&#8377; <strong id='priceVal'>2,999</strong>  <small class="d-inline">+GST</small></p>
      </div>
     
    </div>
  </div>
</section>

<section class="bg-light">
  <div class="container">
  <div class="row align-items-center">
      
      
      <div class="col-md-6">
        <h3>Features</h3>
        <ul class='list-check'>
            <li><span> Regular Location updates(30-60 seconds).</span></li>
            <li><span>Unlimited Live Tracking(30-60 seconds).</span></li>
            <li><span>Active and Sleep wellness features.</span></li>
            <li><span>365 Days Location History.</span></li>
            <li><span>GPS Data export.</span></li>
            <li><span>Geofence Alerts.</span></li>
        </ul>
        
      </div>
      <div class="col-md-6"> <img src="../img/app.png" style={{"width":"350px"}}/> </div>
    </div>
  </div>
</section>




	
	

    <PublicFooter/>
    </>);

}

export default PriceList;